import {
  Grid,
  type GridHandle,
  type GridProps,
} from '@progress/kendo-react-grid'
import classNames from 'classnames'
import React from 'react'

import styles from './StyledGrid.css'

export type StyledGridProps = GridProps & {
  'data-testid'?: string
}

export type StyledGridRef = GridHandle

export const StyledGrid = React.forwardRef<StyledGridRef, StyledGridProps>(
  (
    { className, 'data-testid': dataTestId = 'components-elements-styled-grid', ...rest },
    ref,
  ) => (
    <Grid
      ref={ref}
      className={classNames(styles.root, className)}
      data-testid={dataTestId}
      fixedScroll={true}
      {...rest}
    />
  ),
)
